import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles, HighlightTypeEnum } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const sign: Partial<CaptionStyles> = {
  theme_preset: 'sign',
  pageStyle: {
    color: '#000000'
  },
  wordStyle: {
    inactive: {
      color: '#000000'
    },
    highlightType: HighlightTypeEnum.Box,
    highlightBoxStyle: {
      background: '#ffff00',
      borderRadius: '15px',
      inset: '-10px -20px'
    }
  },
  letterStyle: undefined,
  font_location: getFontFullPath('Oswald-Bold.ttf'),
  caps: true,
  line_config: CaptionLineConfig.OneWord,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.None
  }
};

export default sign;
